// Auth related constants
export enum AuthProvider {
  MAGIC_LINK = 'magic-link',
  GOOGLE = 'google',
  TWITTER = 'twitter',
}

export enum APP_LINKS {
  HOME = '/',
  GENERATE = '/generate',
  FAVORITES = '/favorites',
  HISTORY = '/history',
  SETTINGS = '/settings',
}

export enum MAX_SIZE_PROFILE_PICTURE {
  PROFILE_PICTURE = 5 * 1024 * 1024, // 5MB
}

export enum MAX_TRAINING_IMAGES {
  MIN_TRAINING_IMAGES = 4,
  MAX_TRAINING_IMAGES = 10,
  MAX_TRAINING_IMAGE_SIZE = 70 * 1024 * 1024, // 70MB in bytes
}

export const ASPECT_RATIOS = [
  { value: '1:1', label: '1:1 – 1024px × 1024px' },
  { value: '4:5', label: '4:5 – 1024px × 1280px' },
  { value: '16:9', label: '16:9 – 1024px × 576px' },
];

export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
];
